import React, { forwardRef, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { dataProvider, getProfile, config, getPDF } from "../util";
import Toast from "../components/Toast";
import AlertDialog from "../components/AlertDialog";
import MaterialTable from "material-table";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteRounded from "@material-ui/icons/DeleteRounded";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import SelectAll from "@material-ui/icons/SelectAll";
import ViewColumn from "@material-ui/icons/ViewColumn";
import Invoice from "@material-ui/icons/Description";
import { Refresh, AttachMoney, MoneyOff } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: 10,
    paddingTop: 60,
    // padding: 30,
    // background: "#f3f3f3"
  },
  formRoot: {
    "& > *": {
      //   margin: theme.spacing(1),
      //   minWidth: '100%',
      //   background: 'red'
    },
  },
  flow: {
    width: "100%",
  },
  icon: {
    color: "red",
  },
  section1: {
    marginTop: 20,
  },
  subTitle: {
    color: "#0635C9",
    textAlign: "left",
    fontSize: "1.2em",
  },
}));

export default function ViewEstimates() {
  let history = useHistory();
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [rowdata, setRowData] = useState({});

  //Toast ----------------------------------------
  const [isToastOpen, setIsToastOpen] = React.useState(false);
  const [toastMessage, setToastMessage] = React.useState("");
  // const handleToastOpen = () => {
  //   setIsToastOpen(true);
  // };
  const handleToastClose = () => {
    setIsToastOpen(false);
  };
  // -----------------------------------------------------

  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteRounded {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
    // SelectAll: forwardRef((props, ref) => <SelectAll {...props} ref={ref} />),
    MoneyOff: forwardRef((props, ref) => <MoneyOff {...props} ref={ref} />),
    AttachMoney: forwardRef((props, ref) => <AttachMoney {...props} ref={ref} />),
    SelectAll: forwardRef((props, ref) => <SelectAll {...props} ref={ref} />),
    Refresh: forwardRef((props, ref) => (
      <Refresh
        // style={{ padding: 3, color: "white", backgroundColor: "green" }}
        {...props}
        ref={ref}
      />
    )),
  };

  const [profile, setProfile] = React.useState({ username: "", permission: 0 });
  useEffect(() => {
    loadProfile();
    loadData();
  }, []);

  async function loadProfile() {
    const profile = await getProfile();
    setProfile(profile);
  }

  async function loadData(state = 'all') {
    try {
      const mydata = await dataProvider("get", "/estimates/", []);
      setData(mydata.data);
    } catch (error) {
      console.log(error);
      setToastMessage(error.message);
      setIsToastOpen(true);
    }
  }

  /**
   * Delete a item
   */
  const deleteItem = (rowData) => {
    return new Promise((resolve, reject) => {
      dataProvider("delete", "/estimate", rowData)
        .then((res) => {
          setToastMessage(res.data.message);
          setIsToastOpen(true);
          loadData();
          setDialogOpen(false);
          setRowData({});
          resolve();
        })
        .catch((error) => {
          console.log(error,"err")
          console.log(error.status)
          setToastMessage(error.message);
          setIsToastOpen(true);
          setDialogOpen(false);
          setRowData({});
          reject();
        });
    });
  };
  const view_admin = [
    // {
    //   title: "Status",
    //   render: (rowData) =>
    //    (rowData.total <= 0)? (
    //   //  (rowData.total === "0"  || rowData.total === "0.0")? (
    //       <Chip size="small" label="Paid" color="primary" />
    //     ) : (
    //       <Chip size="small" label="Due" color="secondary" />
    //     ),
    // },

    {
      title: "Estimate#",
      field: "id",
      editable: "never",
    },
    // { title: "Job ID", field: "request_id", editable: "never" },
    { title: "Name", field: "first_name" },
    {
      title: "Surname",
      field: "last_name",
      render: (rowData) => rowData?.last_name.toString(),
    },
    // { title: "Registration", field: "registration" },
    { title: "Amount due", type: "currency", field: "total" },
    {
      title: "Date",
      field: "created_at",
      editable: "never",
      render: (rowData) => (
        <div style={{ minWidth: 100 }}>{rowData.created_at}</div>
      ),
    },
    // { title: "Payments", type: "currency", field: "payment" },
    // {
    //     title: "Status",
    //     field: "invoice_status",
    //     editable: "never",
    //     render: (rowData) =>
    //     rowData.invoice_status !== "write-off" &&
    //         rowData.invoice_status !== "paid" &&

    //       profile?.permission > 2 ? (
    //         <select onChange={(e) => updateStatus(rowData.id, e)}>
    //           {op.map(
    //             (v, i) => {
    //                 let state = rowData.invoice_status.toString();
    //               if (state === v) {
    //                 return (
    //                   <option selected value={v}>
    //                     {v}
    //                   </option>
    //                 );
    //               }
    //              if (state !== v) {
    //                 return <option x='1' value={v}>{v}</option>;
    //               }
    //             }
    //           )}
    //         </select>
    //       ) : (
    //         rowData.invoice_status
    //       ),
    //   },

    // { title: "Updated", field: "updated_on", editable: "never" },
    // { title: "VIN", field: "vin", hidden: true, searchable: true },

    // { title: "VIN", field: "vin",
    // render: (rowData) => (
    //   <div onClick={()=> {copyElementText(rowData.vin);}}>
    //     {rowData.vin}{" "}
    //   </div>
    // ) }
  ];

  return (
    <div className={classes.root}>
      {/* <form className={classes.formRoot} onSubmit={handleSubmit}> */}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MaterialTable
            style={{ fontSize: 14 }}
            title="Estimates"
            columns={view_admin}
            icons={tableIcons}
            data={data ? data : null}
            options={{
              pageSize: 10,
              pageSizeOptions: [10, 20, 50, 100, 500],
              sorting: true,
              search: true,
              exportButton: false,
              rowStyle: (rowData) => {
                // console.log(rowData)
                // if (rowData.tableData.id % 2 === 0) {
                //   return { backgroundColor: "#fceffc" };
                //   return { backgroundColor: "#eaf9f7" };
                // }

                // if (rowData.total === "0" || rowData.total === "0.0") {
                //   return { backgroundColor: "#f8fcea" };
                // }

                // if (rowData.invoice_status === "open") {
                //   return { backgroundColor: "#fff" };
                // }

                // if (rowData.invoice_status === "write-off") {
                //   return { backgroundColor: "#ffdbe6" };
                // }
              },
            }}
            // onRowClick={(event, rowData, togglePanel) => {
            // window.open(config.domain+'/invoice/'+rowData.id);
            // if(rowData.invoice_status === 'open') history.push('view-invoice/?id='+rowData.id)

            // }}
            actions={[
              {
                tooltip: "Refresh All Estimates",
                icon: tableIcons.Refresh,
                position: "toolbar",
                onClick: () => {
                  loadData();
                },

                // onClick: (evt, data) => {(doAll)?setOpenD(true):setShowSnack(true)}
                // onClick: (evt, data) => alert('Confirm delivery for ' + data.length + ' packages')
              },

                // {
                //   icon: tableIcons.MoneyOff,
                //   tooltip: 'Due Invoices',
                //   isFreeAction: true,
                //   onClick: () => {
                //     loadData('due');
                //   },
                // },
              
                // {
                //   icon: tableIcons.AttachMoney,
                //   tooltip: 'Paid Invoices',
                //   isFreeAction: true,
                //   onClick: () => {
                //     loadData('paid');
                //   },
                // },
              
        
              (rowData) => ({
                icon: Invoice,
                tooltip: "View Estimate",
                onClick: (event, rowData) => {
                  // window.open(config.domain+'/invoice/'+rowData.id);
                  getPDF(config.domain + "estimate-pdf/" + rowData.id);
                },
              }),
              // (rowData) => ( profile?.permission > 3 && (rowData.total > 0)
              (rowData) => ( profile?.permission > 3
              ?{
                icon: Edit,
                onClick: () => history.push("view-estimate/?id=" + rowData.id),
              }:null),
              
              (rowData) =>
                profile?.permission > 2
                  ? {
                      icon: tableIcons.Delete,
                      tooltip: "Delete Invoice",
                      onClick: (event, rowData) => {
                        setRowData(rowData);
                        setDialogOpen(true);
                      },
                    }
                  : null,

              // (rowData) => ({
              //   icon: Invoice,
              //   tooltip: "View Invoice",
              //   onClick: (event, rowData) => {
              //           // window.open(config.domain+'/invoice/'+rowData.id);
              //           getPDF(config.domain+'/invoice/'+rowData.id);

              //   }
              // }),
            ]}
          />
        </Grid>
      </Grid>
      {/* </form> */}
      <Toast
        isOpen={isToastOpen}
        handleClose={handleToastClose}
        message={toastMessage}
      />

      <AlertDialog
        isOpen={dialogOpen}
        handleClose={() => setDialogOpen(false)}
        handleAgree={() => deleteItem(rowdata)}
        handleCancel={() => setDialogOpen(false)}
        title="Confirmation"
        subtitle={
          "Delete Estimate #" + rowdata.id + " for " + rowdata.first_name + "?"
        }
        ok="Yes"
        cancel="Cancel"
      />
    </div>
  );
}
